import Cookies from 'js-cookie'

const TokenKey = 'MyAdmin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 保存用户openid
const openidKey = 'openid'
export function getOpenId() {
  return Cookies.get(openidKey)
}
export function setOpenId(openid) {
  return Cookies.set(openidKey, openid)
}
export function removeOpenId(openid) {
  return Cookies.remove(openidKey, openid)
}


const name = 'nickName'
export function getNickName() {
  return Cookies.get(name)
}
export function setNickName(nickName) {
  return Cookies.set(name, nickName)
}
export function removeNickName(nickName) {
  return Cookies.remove(name, nickName)
}


const isWorkMan = 'IsWorkMan'
export function getIsWorkMan() {
  return Cookies.get(isWorkMan)
}
export function setIsWorkMan(IsWorkMan) {
  return Cookies.set(isWorkMan, IsWorkMan)
}
export function removeIsWorkMan(IsWorkMan) {
  return Cookies.remove(isWorkMan, IsWorkMan)
}

// 获取招聘token
const accToken = 'ZPQY-Token'
export function setaccToken(token) {
  return Cookies.set(accToken, token)
}
export function getaccToken() {
  return Cookies.get(accToken)
}
export function removeaccToken() {
  return Cookies.remove(accToken)
}

// 获取员工token
const staffToken = 'YGDL-Token'
export function setstaffToken(token) {
  return Cookies.set(staffToken, token)
}
export function getstaffToken() {
  return Cookies.get(staffToken)
}
export function removestaffToken() {
  return Cookies.remove(staffToken)
}
// 获取网格管理token
const wgToken = 'WGGL-Token'
export function setwgToken(token) {
  return Cookies.set(wgToken, token)
}
export function getwgToken() {
  return Cookies.get(wgToken)
}
// 获取59岁老人采集token
const oldmanToken = 'LRCJ-Token'
export function setoldmanToken(token) {
  return Cookies.set(oldmanToken, token)
}
export function getoldmanToken() {
  return Cookies.get(oldmanToken)
}
export function removeoldmanToken() {
  return Cookies.remove(oldmanToken)
}

// 获取养老美团订单id
const ylOrderId = 'Order-Id'
export function setOrderId(id) {
  return Cookies.set(ylOrderId, id)
}
export function getOrderId() {
  return Cookies.get(ylOrderId)
}
export function removeOrderId() {
  return Cookies.remove(ylOrderId)
}

// 获取服务站登记
const StaLevel = 'staLevel'
export function setStaLevel(id) {
  return Cookies.set(StaLevel, id)
}
export function getStaLevel() {
  return Cookies.get(StaLevel)
}
export function removeStaLevel() {
  return Cookies.remove(StaLevel)
}

// 获取登录社区编码
const OCode = 'oCode'
export function setOCode(id) {
  return Cookies.set(OCode, id)
}
export function getOCode() {
  return Cookies.get(OCode)
}
export function removeOCode() {
  return Cookies.remove(OCode)
}
